import React from 'react'
import { useModal } from '@mprolab/uikit'
import ConfirmTransactionModal from './ConfirmTransactionModal'

export interface ReturnType {
  onPresentConfirmTransactionModal: () => void
  onDismissConfirmTransactionModal: () => void
}

const useConfirmTransactionModal = (): ReturnType => {
  const [onPresent, onDismissConfirmTransactionModal] = useModal(<ConfirmTransactionModal />, false)

  const onPresentConfirmTransactionModal = () => onPresent()

  return { onPresentConfirmTransactionModal, onDismissConfirmTransactionModal }
}

export default useConfirmTransactionModal
